"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var reducers = {
    flags: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SAVE_FEATURE_FLAG] = function (draftState, action) {
            var _a = action.payload, name = _a.name, value = _a.value;
            if (name) {
                draftState[name] = value;
            }
        },
        _a[constants_1.SAVE_ALL_FEATURE_FLAGS] = function (draftState, action) {
            return action.payload;
        },
        _a), {}),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map